module.exports = __webpack_public_path__ + "media/images/icon_sort_active-41213f8168435c85a1718d052dd85cd2.png";